// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import mushodoPromise from '@webapp-next/lib/request/webapp/mushodo-promise';

export type AccountContext = {
  CsmName?: string | null | undefined;
  CsmEmail?: string | null | undefined;
};

export type CreditCard = {
  BillingAddress: string;
  BillingCity: string;
  BillingCountry: string;
  BillingPostcode: string;
  BillingState: string;
  BillingVatId: string | null;
  ExpirationMonth: number;
  ExpirationYear: number;
  FirstName: string;
  LastName: string;
  MaskedNumber: string;
  Name: string;
  PaymentMethodType: string;
  CreditCardType?: string;
};

export type PayPal = {
  PaymentMethodType: string;
  PaypalEmail: string;
  PaypalBaid?: string;
};

export type BankTransfer = {
  PaymentMethodType: string;
  BankTransferAccountNumberMask: string;
  BankTransferAccountName?: string;
  BankCode?: string;
  BankName?: string;
  BankTransferType?: string;
  BankBranchCode?: string;
  BankCity?: string;
  BankPostalCode?: string;
  BankStreetName?: string;
  BankStreetNumber?: string;
  CustomerFirstName?: string;
  CustomerLastName?: string;
  CustomerCity?: string;
  CustomerCountry?: string;
  CustomerPostalCode?: string;
  CustomerState?: string;
  CustomerStreetName?: string;
  CustomerStreetNumber?: string;
};

export type ACH = {
  PaymentMethodType: string;
  AchAccountNumberMask: string;
  AchAccountName?: string;
  AchAccountType?: string;
  AchAbaCode?: string;
  AchBankName?: string;
  AchAddress1?: string;
  AchAddress2?: string;
  AchCity?: string;
  AchCountry?: string;
  AchPostalCode?: string;
  AchState?: string;
};

export type AddOnProduct = {
  planIdentifier: string;
  trialAvailable: boolean;
  status: string;
  terminationDate: string;
  trialEndDate: string;
  trialStartDate: string;
  parentAddOn: string;
  equivalentPaymentFrequencyPlans: Record<string, string>;
  startBillingDate?: string;
};

export type BillingContact = {
  BillingAddress: string;
  BillingCity: string;
  BillingContactAdditionalEmail: string | null;
  BillingContactEmail: string;
  BillingCountry: string;
  BillingPostcode: string;
  BillingState: string;
  BillingVatId: string | null;
  FirstName: string;
  LastName: string;
};

export type CompanyContact = {
  CompanyAddress: string;
  CompanyCity: string;
  CompanyCountry: string;
  CompanyFirstName: string;
  CompanyLastName: string;
  CompanyPostcode: string;
  CompanyState: string;
  BillingLegalBusinessName: string | null;
  BillingPstId: string | null;
  BillingVatId: string | null;
};

export type SubscriptionDataApiResponse = {
  BillingContact: BillingContact;
  CompanyContact: CompanyContact;
  AccountContext?: AccountContext;
  CreditCard?: CreditCard;
  PayPal?: PayPal;
  BankTransfer?: BankTransfer;
  ACH?: ACH;
  EMPLOYEE_QUANTITY_PREPURCHASE: number;
  NextBillingDate: string;
  PaymentMethodType: string;
  SubscriptionEndDate: string;
  SubscriptionStartDate: string;
  SubscriptionType: number;
  TermEndDate: string;
  TermStartDate: string;
  TrialRemaining: number;
  UOM: string;
  addOnProducts: Record<string, AddOnProduct>;
  allowMoveFromAnnualToMonthly: boolean;
  channel: string;
  mobileMetadata?: {
    maxUserAllowed: number;
    subscriptionID: string;
    channel: string;
    conversionDate: string;
    nextBillingDate: string;
    trialStartDate: string;
    originalTxID: string;
  };
  eligibleForAppleToDeputySelfServe?: boolean;
  isSubscriptionPaused: boolean;
  lastPausedOn: string;
  lastResumedOn: string;
  recentlyConvertedFromAnnualToMonthly: boolean;
  isAioBundle?: boolean;
  status: string;
  featureFlags: Record<string, boolean>;
  promoCampaigns?: import('@apps-billing-shared/composables/resolve-promo-campaigns').ResolvedPromoCampaign[];
};

export function loadSubscription(
  hostname: string
): Promise<SubscriptionDataApiResponse> {
  return mushodoPromise<SubscriptionDataApiResponse>(
    'GetSubscription',
    hostname
  );
}
